<template>
  <el-container>
    <el-main>
      <el-form ref="searchData" :model="searchData" label-width="80px" label-position="top" >
        <el-row :gutter="0" justify="center">
          <el-col :span="4" class="cls-col">
            <el-form-item label="课程名" prop="courseName">
              <el-input v-model="searchData.courseName" placeholder="课程名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="直播名称" prop="className">
              <el-input v-model="searchData.className" placeholder="直播名称" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col" >
            <el-form-item label="姓名" prop="realName">
            <el-input v-model="searchData.realName" placeholder="姓名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="是否发放课酬" clearable prop="status">
              <el-select
                  v-model="searchData.isPayed"
                  clearable
                  placeholder="是否发放课酬"
                  size="small"
                  style="width: 100%"
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0" justify="center">
          <el-col :span="8" class="cls-col">
            <el-form-item label="日期" prop="phone" >
              <el-date-picker
                  v-model="searchData.dateBegin"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small"
              >
              </el-date-picker>
              -
              <el-date-picker
                  arrow-control
                  v-model="searchData.dateEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="cls-col">
            <el-form-item label="开始时间" prop="phone" >
              <el-time-picker
                v-model="searchData.timeBegin"
                placeholder="开始时间"
                format="HH:mm"
                value-format="HH:mm:ss"
                size="small"
              >
            </el-time-picker>
              -
              <el-time-picker
                  v-model="searchData.timeEnd"
                  placeholder="结束时间"
                  value-format="HH:mm:ss"
                  format="HH:mm"
                  size="small"
                  >
              </el-time-picker>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
          <el-form-item>
            <el-button
                type="primary"
                plain
                size="small"
                icon="el-icon-search"
                @click="search()"
            >查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
                type="text"
                size="medium"
                icon="icon-blcu-fafang"
                @click="giveClass()"
            >批量发放课酬
            </el-button>
            <span style="margin-left: 30px">课时合计数：{{totalHours}}</span>
          </el-form-item>
        </el-row>
  
      </el-form>
      <el-table
          :data="liveData"
          border
          highlight-current-row
          @selection-change="handleSelectionChange"
          style="width: 100%"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50" ></el-table-column>
        <el-table-column prop="date" label="日期" width="100" ></el-table-column>
        <el-table-column prop="startTime" label="开始时间" width="100" ></el-table-column>
        <el-table-column prop="courseName" label="课程名"  ></el-table-column>
        <el-table-column prop="className" label="直播名称（课节名）" width="230" ></el-table-column>
        <el-table-column prop="userName" label="用户名（授课教师）" width="230" ></el-table-column>
        <el-table-column prop="realName" label="姓名（授课教师）" width="200"></el-table-column>
        <el-table-column prop="teachingHour" label="课时数" width="100">
          <template slot-scope="scope">
            <el-input
                v-if="scope.row.teachingHour != null"
                v-model="scope.row.teachingHour"
                size="small"
                @change="changeTeachingHour(scope.row)"
                @fous="fousTeachingHour(scope.row)"
                @input="validateNumber(scope.row.teachingHour,(data)=>{scope.row.teachingHour = data})"
            ></el-input>
            <el-input
                v-if="scope.row.teachingHour == null"
                v-model="scope.row.autoTeachingHours"
                size="small"
                @change="changeTeachingHour(scope.row,1)"
                @fous="fousTeachingHour(scope.row)"
                @input="validateNumber(scope.row.autoTeachingHours,(data)=>{scope.row.autoTeachingHours = data})"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="isPayed" label="是否发放课酬" width="120">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.isPayed"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                @change="changePayed(scope.row)"
                inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.operationType==1">未开始</span>
            <span v-if="scope.row.operationType==3">已结束</span>
            <span v-if="scope.row.operationType==2">进行中</span>
            <el-button v-if="scope.row.operationType==4" @click="replay(scope.row)" type="text" >回放</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px"
      ></el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  
  export default {
    name: 'live',
    data() {
      return {
        totalHours: 0,
        selectedClass: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        liveData: [],
        oldRow: {},
        searchData: {
          courseName: '',
          className: '',
          userName: '',
          realName: '',
          isPayed: '',
          dateBegin: '',
          dateEnd: '',
          timeBegin: '',
          courseName: '',
          page: 1,
          size: 0,
        }
        
      };
    },
    
    methods: {
      giveClass() {
        if(!this.totalHours) {
          this.$message({
            type: 'info',
            message: "请选择需要方法的课酬！"
          });
        }
        this.$confirm('确定发放课酬?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = "";
          for(let selected of this.selectedClass) {
            ids += selected.id+",";
          }
          let params = {
            ids: ids,
            isPayed: 1
          };
          this.https.fetchPost('/appointmentManagerInfo/configure', params, 'json').then((data) => {
                let code = data.data.code;
                let msg = data.data.msg;
                if (code == '200') {
                  this.$message({
                    type: 'success',
                    message: '发放成功!'
                  });
                  this.search();
                } else {
                  this.$message({
                    type: 'info',
                    message: '发放失败:' + msg
                  });
                }
              }).catch((err) => {
                this.$message.error('网络异常！');
              });
        }).catch(() => {
        
        });
      },
      handleSelectionChange(val) {
        this.totalHours = 0;
        this.selectedClass = [];
        for(let row of val) {
          console.log(row);
          if(row.teachingHour != null) {
            this.totalHours += Number.parseInt(row.teachingHour);
          }else {
            this.totalHours += Number.parseInt(row.autoTeachingHours);
          }
        }
        this.selectedClass = val;
      },
      
      goLive(row) {
        let params = {
          classUid: row.classUid,
        };
        this.https.fetchPost('/live/searchClassinMeeting', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data.tecUrl) {
              window.open(data.data.data.tecUrl)
            } else {
              this.$message({
                type: 'info',
                message: "未能获取到直播间地址！"
              });
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      replay(row) {
        window.open(row.liveUrl);
      },
      changePayed(row) {
        let params = {
          ids: row.id,
          isPayed: row.isPayed
        };
        this.https.fetchPost('/appointmentManagerInfo/configure', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
          
          } else {
            this.$message({
              type: 'info',
              message: '修改失败:' + msg
            });
            let isPayed = row.isPayed==1?0:1;
            row.isPayed = isPayed;
          }
        }).catch((err) => {
          this.$message.error('网络错误');
          let isPayed = row.isPayed==1?0:1;
          row.isPayed = isPayed;
        });
      },
      
      fousTeachingHour(row) {
        this.oldRow = row;
      },
      validateNumber(value,collback) {
        value = value.replace(/[^\d]/g,'');
        if(value == "00") {
          value = 0;
        }
        value = (value+'').substr(0,2);
        value = isNaN(value) ? 0 : value;
        collback(value);
      },
      changeTeachingHour(row, flag) {
        if(flag) {
          row.teachingHour = row.autoTeachingHours;
        }
        
        let params = {
          ids: row.id,
          teachingHour: row.teachingHour
        };
        this.https.fetchPost('/appointmentManagerInfo/configure', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
          
          } else {
            this.$message({
              type: 'info',
              message: '修改失败:' + msg
            });
            row.teachingHour = this.oldRow.teachingHour;
            row.autoTeachingHours = this.oldRow.autoTeachingHours;
          }
        }).catch((err) => {
          this.$message.error('网络错误');
          row.teachingHour = this.oldRow.teachingHour;
        });
        
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.https.fetchPost('/appointmentManagerInfo/meets', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.liveData = data.data.data;
                this.total = data.data.total;
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }
            }).catch((err) => {
              this.$message.error('网络错误');
            });
      },
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
    },
    created: function() {
      this.search();
    }
  };
</script>

<style scoped>

</style>
